import {TablePaginationConfig} from 'antd';
import {FilterValue, SorterResult} from 'antd/es/table/interface';
import {showCommunicationError} from 'helpers/alerts';
import {action, makeObservable, observable, runInAction} from 'mobx';
import {SortDirection} from '../../../../../PRMGApiClient';
import {Api} from '../../../../../PRMGApiClient/ApiClient';

export abstract class TableState<T extends object, F extends object> {
  @observable
  public items: T[] = [];

  public filters: F = {} as F;

  @observable
  pageNumber: number = 1;

  @observable
  pageSize: number = 10;

  @observable
  total: number = 0;

  @observable
  isLoading: boolean = false;

  sortPropertyName: string = 'id';

  sortDirection: SortDirection = SortDirection.Asc;

  filtersCarName: string | undefined;

  filtersCarId: number | undefined;

  constructor() {
    makeObservable(this);
  }

  abstract loadTableItems(): void;

  abstract setFilters(filters: Record<keyof T, FilterValue | null>): void;

  @action
  setPagination(pagination: TablePaginationConfig) {
    this.pageNumber = pagination.current || 1;
    this.pageSize = pagination.pageSize || 10;
    this.loadTableItems();
  }

  @action
  setSorters(sorters: SorterResult<T>) {
    this.sortPropertyName = sorters.field as string;
    this.sortDirection = sorters.order === 'ascend' ? SortDirection.Asc : SortDirection.Desc;
    this.loadTableItems();
  }

  @action
  setFiltersVehicle(vehicleId?: number) {
    if (vehicleId) {
      Api.Car.getCarById({id: vehicleId})
        .then((res) => {
          runInAction(() => {
            this.filtersCarName =
              res.content?.carModelName + ' ' + res.content?.carMakeName + ' ' + res.content?.manufactureYear;
            this.filtersCarId = vehicleId;
            this.loadTableItems();
          });
        })
        .catch(showCommunicationError);
    } else {
      this.filtersCarName = undefined;
      this.filtersCarId = undefined;
      this.loadTableItems();
    }
  }

  getDate = (keys: FilterValue | null) => {
    return keys?.[0] ? new Date(keys[0] as string) : undefined;
  };
}
